/**
 * Locale-safe date formatting helpers.
 *
 * Problem this solves: `new Date("2026-05-26")` is parsed as UTC midnight,
 * which shifts back to the previous day in any negative-offset timezone
 * (Eastern, Central, etc.) when format() then renders in local time.
 *
 * For pure date strings (YYYY-MM-DD), we explicitly construct a Date with
 * local-time components so what the user picked is what gets shown.
 */
import { format } from "date-fns";

function parseLocal(d) {
    if (!d) return null;
    // Pure date-only (YYYY-MM-DD) → build as local midnight
    if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
        const [y, m, day] = d.split("-").map(Number);
        return new Date(y, m - 1, day);
    }
    // Full ISO datetime or other formats → trust JS to parse
    const dt = new Date(d);
    return isNaN(dt.getTime()) ? null : dt;
}

export function fmtDate(d, pattern = "MMM d, yyyy", fallback = "—") {
    const dt = parseLocal(d);
    if (!dt) return fallback;
    try { return format(dt, pattern); } catch { return d; }
}

export function fmtDateShort(d, fallback = "—") {
    return fmtDate(d, "MMM d", fallback);
}
